import { Route } from "react-router-dom"
import { AppRoutes } from "@constants/AppRoutes.ts"
import { AppAuthorizedProfiles } from "@constants/AppAuthorizedProfiles.ts"

import UserProfile from "@pages/UserProfile/UserProfile.tsx"
import BookSpacePlace from "@pages/BookSpacePlace/BookSpacePlace.tsx"
import ProtectedRoute from "@components/others/PrivateRoute/PrivateRoute.tsx"
import UserProfileInfo from "@pages/UserProfileInfo/UserProfileInfo.tsx"
import BookSpaceSchedule from "@pages/BookSpaceSchedule/BookSpaceSchedule.tsx"

const UserProfileRoutes = () => {
	return (
		<Route
			path={AppRoutes.userProfileRoot}
			element={
				<ProtectedRoute
					authorizedProfiles={[AppAuthorizedProfiles.MEMBERSHIP]}
				>
					<UserProfile />
				</ProtectedRoute>
			}
		>
			<Route path={AppRoutes.userProfile} element={<UserProfileInfo />} />

			<Route
				path={AppRoutes.userProfileBookSpace_place}
				element={<BookSpacePlace />}
			/>

			<Route
				path={AppRoutes.userProfileBookSpace_schedule}
				element={<BookSpaceSchedule />}
			/>
		</Route>
	)
}

export default UserProfileRoutes
